export default "__VITE_ASSET__DJxcv$mc__"